export default "__VITE_ASSET__s$vYMufh__"